import { render } from "./AddSign.vue?vue&type=template&id=5b7027d6&scoped=true"
import script from "./AddSign.vue?vue&type=script&lang=js"
export * from "./AddSign.vue?vue&type=script&lang=js"

import "./AddSign.vue?vue&type=style&index=0&id=5b7027d6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5b7027d6"

export default script